import contenttitleutils from '@/utils/contenttitleutils';

export default {
  methods: {
    ...contenttitleutils,
  },
};
